/* Maison Flash — theme scripts */
(function () {
  'use strict';

  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));
  const S = (window.theme && window.theme.strings) || {};
  const pad = (n) => String(n).padStart(2, '0');

  /* ---------------- Money ---------------- */
  function formatMoney(cents) {
    const format = (window.theme && window.theme.moneyFormat) || '{{amount_with_comma_separator}} €';
    const value = (cents / 100).toFixed(2);
    const [int, dec] = value.split('.');
    const withSpaces = int.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    const withDots = int.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    const withCommas = int.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount': return `${withCommas}.${dec}`;
        case 'amount_no_decimals': return withCommas;
        case 'amount_with_comma_separator': return `${withDots},${dec}`;
        case 'amount_no_decimals_with_comma_separator': return withDots;
        case 'amount_with_space_separator': return `${withSpaces},${dec}`;
        case 'amount_with_apostrophe_separator': return `${int.replace(/\B(?=(\d{3})+(?!\d))/g, "'")}.${dec}`;
        default: return `${withDots},${dec}`;
      }
    });
  }

  /* ---------------- Drawers ---------------- */
  let lastFocus = null;
  function openDrawer(id) {
    const el = document.getElementById(id);
    if (!el) return;
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    const focusable = el.querySelector('button, a, input');
    if (focusable) setTimeout(() => focusable.focus(), 50);
  }
  function closeDrawer(el) {
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open-drawer]');
    if (opener) {
      if (opener.dataset.openDrawer === 'CartDrawer' && !document.getElementById('CartDrawer')) return;
      e.preventDefault();
      openDrawer(opener.dataset.openDrawer);
      return;
    }
    const closer = e.target.closest('[data-close-drawer]');
    if (closer) {
      e.preventDefault();
      closeDrawer(closer.closest('.drawer, .modal'));
    }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    $$('.drawer.is-open, .modal.is-open').forEach(closeDrawer);
  });

  /* ---------------- Search toggle ---------------- */
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-search-toggle]');
    if (!t) return;
    e.preventDefault();
    const bar = $('#HeaderSearch');
    if (!bar) return;
    bar.classList.toggle('is-open');
    if (bar.classList.contains('is-open')) $('input', bar).focus();
  });

  /* ---------------- Countdowns ---------------- */
  function parseDate(str) {
    if (!str) return null;
    // Accept "2026-10-12", "2026-10-12 20:00", "2026-10-12T20:00:00+02:00"
    let s = str.trim();
    if (/^\d{4}-\d{2}-\d{2}$/.test(s)) s += 'T23:59:59';
    s = s.replace(' ', 'T');
    const d = new Date(s);
    return isNaN(d) ? null : d;
  }
  function split(ms) {
    const total = Math.max(0, Math.floor(ms / 1000));
    return {
      d: Math.floor(total / 86400),
      h: Math.floor((total % 86400) / 3600),
      m: Math.floor((total % 3600) / 60),
      s: total % 60
    };
  }
  function tickCountdowns() {
    const now = Date.now();

    $$('[data-countdown-end]').forEach((el) => {
      const end = parseDate(el.dataset.countdownEnd);
      if (!end) return;
      const diff = end - now;
      const card = el.closest('[data-sale]');
      const lastDay = card && $('[data-last-day]', card);
      if (diff <= 0) {
        el.textContent = S.ended || 'Vente terminée';
        if (lastDay) lastDay.hidden = true;
        return;
      }
      const t = split(diff);
      if (lastDay) lastDay.hidden = diff > 86400000;

      if (el.hasAttribute('data-countdown-units')) {
        const set = (k, v) => { const n = $(`[data-unit="${k}"]`, el); if (n) n.textContent = pad(v); };
        set('d', t.d); set('h', t.h); set('m', t.m); set('s', t.s);
        return;
      }
      el.textContent = t.d > 0
        ? `${S.endsIn || 'Se termine dans'} ${t.d}${S.days || 'j'} ${t.h}${S.hours || 'h'}`
        : `${pad(t.h)}:${pad(t.m)}:${pad(t.s)}`;
    });

    $$('[data-countdown-start]').forEach((el) => {
      const start = parseDate(el.dataset.countdownStart);
      if (!start) return;
      const diff = start - now;
      if (diff <= 0) { el.textContent = el.dataset.liveLabel || 'En cours'; return; }
      const today = new Date(); today.setHours(0, 0, 0, 0);
      const startDay = new Date(start); startDay.setHours(0, 0, 0, 0);
      const days = Math.round((startDay - today) / 86400000);
      if (days <= 0) {
        const t = split(diff);
        el.textContent = `${S.startsIn || 'Commence dans'} ${pad(t.h)}:${pad(t.m)}:${pad(t.s)}`;
      } else if (days === 1) {
        el.textContent = S.tomorrow || 'Commence demain';
      } else {
        el.textContent = `${S.startsIn || 'Commence dans'} ${days} ${S.days === 'd' ? 'days' : 'jours'}`;
      }
    });
  }
  tickCountdowns();
  setInterval(tickCountdowns, 1000);

  /* ---------------- Scrollers ---------------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-scroll]');
    if (!btn) return;
    const track = $('.scroller__track', btn.closest('[data-scroller]'));
    if (!track) return;
    const dir = btn.dataset.scroll === 'next' ? 1 : -1;
    track.scrollBy({ left: dir * track.clientWidth * 0.8, behavior: 'smooth' });
  });

  /* ---------------- Cart ---------------- */
  async function refreshCart(open) {
    try {
      const res = await fetch(`${window.theme.routes.root_url.replace(/\/$/, '')}/?sections=cart-drawer`);
      const data = await res.json();
      const html = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
      const fresh = $('#CartDrawer', html);
      const current = $('#CartDrawer');
      if (fresh && current) {
        $('.drawer__panel', current).innerHTML = $('.drawer__panel', fresh).innerHTML;
      }
      const cart = await (await fetch('/cart.js')).json();
      $$('[data-cart-count]').forEach((el) => {
        el.textContent = cart.item_count;
        el.dataset.count = cart.item_count;
      });
      updateReservation(cart.item_count);
      if (open && current) openDrawer('CartDrawer');
    } catch (err) {
      console.error(err);
    }
  }

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-product-form]');
    if (!form) return;
    if (window.theme.cartType === 'page') return;
    e.preventDefault();
    const btn = $('[type="submit"]', form);
    const label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    try {
      const res = await fetch(window.theme.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      });
      const data = await res.json();
      if (!res.ok) {
        const msg = $('[data-form-error]', form);
        if (msg) { msg.textContent = data.description || data.message; msg.hidden = false; }
        return;
      }
      await refreshCart(true);
    } finally {
      if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); btn.innerHTML = label; }
    }
  });

  async function changeLine(line, quantity) {
    await fetch(window.theme.routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line, quantity })
    });
    if (document.body.classList.contains('template-cart')) {
      window.location.reload();
    } else {
      refreshCart(false);
    }
  }
  document.addEventListener('click', (e) => {
    const q = e.target.closest('[data-line-qty]');
    if (q) {
      e.preventDefault();
      const wrap = q.closest('[data-line]');
      const input = $('input', wrap);
      const next = Math.max(0, parseInt(input.value, 10) + parseInt(q.dataset.lineQty, 10));
      changeLine(parseInt(wrap.dataset.line, 10), next);
      return;
    }
    const r = e.target.closest('[data-line-remove]');
    if (r) {
      e.preventDefault();
      changeLine(parseInt(r.dataset.lineRemove, 10), 0);
    }
  });

  /* Cart reservation timer (per-browser convenience) */
  const RES_KEY = 'mf_cart_reserved_at';
  function updateReservation(count) {
    const minutes = parseInt((window.theme && window.theme.reservationMinutes) || 0, 10);
    if (!minutes) return;
    try {
      if (!count) { localStorage.removeItem(RES_KEY); return; }
      if (!localStorage.getItem(RES_KEY)) localStorage.setItem(RES_KEY, String(Date.now()));
    } catch (_) { /* storage unavailable */ }
  }
  function tickReservation() {
    const minutes = parseInt((window.theme && window.theme.reservationMinutes) || 0, 10);
    const els = $$('[data-reservation]');
    if (!minutes || !els.length) return;
    let start = Date.now();
    try { start = parseInt(localStorage.getItem(RES_KEY), 10) || Date.now(); } catch (_) {}
    let left = start + minutes * 60000 - Date.now();
    if (left < 0) {
      try { localStorage.setItem(RES_KEY, String(Date.now())); } catch (_) {}
      left = minutes * 60000;
    }
    const t = split(left);
    els.forEach((el) => { el.textContent = `${pad(t.m + t.h * 60)}:${pad(t.s)}`; });
  }
  setInterval(tickReservation, 1000);
  document.addEventListener('DOMContentLoaded', () => {
    const c = $('[data-cart-count]');
    if (c) updateReservation(parseInt(c.dataset.count || '0', 10));
    tickReservation();
  });

  /* ---------------- Product: variants & qty ---------------- */
  function initProduct(root) {
    const json = $('[data-product-json]', root);
    if (!json) return;
    const product = JSON.parse(json.textContent);
    const form = $('form[data-product-form]', root);
    const idInput = $('input[name="id"]', form);
    const btn = $('[data-add-button]', form);

    function selectedOptions() {
      return $$('[data-option-index]', root).map((fs) => {
        const checked = $('input:checked', fs);
        return checked ? checked.value : null;
      });
    }
    function update() {
      const opts = selectedOptions();
      const variant = opts.length
        ? product.variants.find((v) => v.options.every((o, i) => o === opts[i]))
        : product.variants[0];
      $$('[data-option-index]', root).forEach((fs) => {
        const idx = parseInt(fs.dataset.optionIndex, 10);
        const labelValue = $('[data-selected-value]', fs.closest('.option'));
        const checked = $('input:checked', fs);
        if (labelValue && checked) labelValue.textContent = checked.value;
        $$('input', fs).forEach((input) => {
          const test = opts.slice(); test[idx] = input.value;
          const ok = product.variants.some((v) => v.available && v.options.every((o, i) => o === test[i]));
          input.classList.toggle('is-unavailable', !ok);
        });
      });
      if (!variant) {
        btn.disabled = true;
        btn.textContent = S.unavailable || 'Indisponible';
        return;
      }
      idInput.value = variant.id;
      btn.disabled = !variant.available;
      btn.textContent = variant.available ? (S.addToCart || 'Ajouter au panier') : (S.soldOut || 'Épuisé');

      const price = $('[data-price]', root);
      if (price) {
        const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        price.classList.toggle('price--on-sale', !!onSale);
        $('[data-price-current]', price).textContent = formatMoney(variant.price);
        const cmp = $('[data-price-compare]', price);
        const pct = $('[data-price-percent]', price);
        if (cmp) { cmp.hidden = !onSale; if (onSale) cmp.textContent = formatMoney(variant.compare_at_price); }
        if (pct) {
          pct.hidden = !onSale;
          if (onSale) pct.textContent = `-${Math.round((1 - variant.price / variant.compare_at_price) * 100)}%`;
        }
      }
      const stock = $('[data-stock]', root);
      if (stock && stock.dataset.inventory) {
        const inv = JSON.parse(stock.dataset.inventory)[variant.id];
        stock.hidden = inv === undefined;
        if (inv !== undefined) {
          stock.className = 'product__stock' + (inv <= 0 ? ' product__stock--out' : inv <= 5 ? ' product__stock--low' : '');
          stock.textContent = inv <= 0 ? (S.soldOut || 'Épuisé') : inv <= 5 ? stock.dataset.lowLabel.replace('[count]', inv) : stock.dataset.inLabel;
        }
      }
      if (variant.featured_media) {
        const img = $(`[data-media-id="${variant.featured_media.id}"]`, root);
        if (img) img.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }
    root.addEventListener('change', (e) => { if (e.target.closest('[data-option-index]')) update(); });
    update();
  }
  $$('[data-product]').forEach(initProduct);

  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-qty]');
    if (!b) return;
    e.preventDefault();
    const input = $('input', b.closest('.qty'));
    input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.dataset.qty, 10));
  });

  /* ---------------- Sale alert modal ---------------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-sale-alert]');
    if (!b) return;
    e.preventDefault();
    const modal = $('#AlertModal');
    if (!modal) return;
    $('[data-alert-brand]', modal).textContent = b.dataset.saleAlert;
    $('input[name="contact[tags]"]', modal).value = `newsletter,alerte-${b.dataset.saleAlertHandle || ''}`;
    lastFocus = b;
    modal.classList.add('is-open');
    setTimeout(() => $('input[type="email"]', modal).focus(), 50);
  });
  document.addEventListener('click', (e) => {
    if (e.target.classList && e.target.classList.contains('modal')) e.target.classList.remove('is-open');
  });

  /* ---------------- Collection filters ---------------- */
  document.addEventListener('change', (e) => {
    const f = e.target.closest('form[data-filter-form]');
    if (!f) return;
    if (e.target.type === 'number') return;
    f.submit();
  });
  document.addEventListener('click', (e) => {
    $$('details.filter[open]').forEach((d) => { if (!d.contains(e.target)) d.removeAttribute('open'); });
  });
})();
